<template>
    <placement>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="studentjobs" :searchlink="route('placement.job.students.search',companyjob.id)" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Job Students')">
                <template #roll_no="data">
                    {{data.item.student.roll_no}}
                </template>
                <template #student="data">
                    {{data.item.student.first_name}} {{data.item.student.last_name}}
                </template>
                <template #applied_date="data">
                    {{convertDate(data.item.created_at)}}
                </template>
                <template #placed_at="data">
                    {{data.item.placed_at?convertDate(data.item.placed_at):''}}
                </template>
                <template #experience_letter="data">
                    <a :href="data.item.experience_letter" v-if="data.item.experience_letter" class="text-indigo-500">View</a>
                </template>
            </breeze-table>
        </div>
    </placement>
</template>

<script>
    import Placement from '@/Pages/Placement/Placement'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Placement,
            BreezeTable,
            ButtonLink
        },
        props:['studentjobs','companyjob'],
        data(){
            return{
                fields:[{'key':'roll_no','label':'Roll No'},{'key':'student','label':'Student Name'},{'key':'applied_date','label':'Applied Date'},{'key':'placed_at','label':'Place At'},{'key':'experience_letter','label':'Experience Letter'}]
            }
        },
    }
</script>
